import React from 'react'
import styled from 'styled-components/macro'
import { Stack } from '@mui/material'
import loadComponent from 'src/utils/loadMFE'
import { spacing } from 'src/utils/styled'
import { useNavigate } from 'react-router-dom'
import { Training, Workflow } from 'types/traiwiss'
import RouteContainer from 'src/components/App/RouteContainer'
import { Certificate } from 'types/certification'
import { getCertificationUrl } from 'src/utils/env'
import { useFlightDeck } from 'src/context/FlightDeckContext'

const EventParticipationDashboard = React.lazy(() => loadComponent('traiwiss', 'ParticipationDashboard'))
const MyCertificateList = React.lazy(() => loadComponent('certification', 'MyCertificateList'))

const StyledStack = styled(Stack)`
    margin-top: ${spacing(2)};
    flex: 1;
    max-width: 100%;

    max-height: calc(
        100vh - ${spacing(8)} - ${spacing(4)} - ${spacing(4)} - ${spacing(6)}
    ); // Spacings TopBar, Breadcrumb, margin-top, FooterSpacer
`

const StyledBox = styled(Stack)`
    margin-top: ${spacing(0)};
`

const StyledMyCertificatesBox = styled(Stack)`
    margin-top: ${spacing(2)};
`

export function EventParticipationDashboardRoute() {
    const { academy } = useFlightDeck()
    const navigate = useNavigate()

    const handlePrimaryButtonClicked = () => {
        navigate('/events/calendar/participate')
    }

    const handleGotoVideoGallery = () => {
        navigate('/video-gallery')
    }

    const handleGotoTraining = (training: Training) => {
        navigate('/trainings/' + training._id)
    }

    const handleGotoWorkflow = (workflow: Workflow) => {
        navigate('/workflows/' + workflow._id)
    }

    const handleStartCertificate = (certificate: Certificate) => {
        window.open(`${getCertificationUrl()}/certificate/${certificate._id}`, '_blank')
    }

    const handleGotoPlayback = (playbackId: string) => {
        navigate('/playback/' + playbackId)
    }

    return (
        <RouteContainer wide>
            <StyledStack direction="column">
                <StyledBox>
                    <EventParticipationDashboard onGotoTraining={handleGotoTraining} onGotoWorkflow={handleGotoWorkflow} onGotoPlayback={handleGotoPlayback} academyId={academy?._id} onCalendarButtonClicked={handlePrimaryButtonClicked} onVideoGalleryClicked={handleGotoVideoGallery} />
                </StyledBox>
                <StyledMyCertificatesBox>
                    <MyCertificateList onStartCertificate={handleStartCertificate} onRetryCertificate={handleStartCertificate} />
                </StyledMyCertificatesBox>
            </StyledStack>
        </RouteContainer>
    )
}
